import { render } from "./UnivindexComponent.vue?vue&type=template&id=7aff7e6a"
import script from "./UnivindexComponent.vue?vue&type=script&lang=js"
export * from "./UnivindexComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\frontend\\inso-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__